module.exports = __webpack_public_path__ + "static/media/truck.3a4cdaf9.svg";